// Transitions & Animation Style Plugin
export default {
    id: 'transitions',
    label: 'Transitions',
    icon: 'Activity',
    properties: {
        transitionProperty: {
            label: 'Property',
            type: 'select',
            options: ['transition', 'transition-none', 'transition-all', 'transition-colors', 'transition-opacity', 'transition-shadow', 'transition-transform'],
            default: 'transition',
            toClass: (value) => value || null,
            fromClass: (className) => {
                const options = ['transition', 'transition-none', 'transition-all', 'transition-colors', 'transition-opacity', 'transition-shadow', 'transition-transform'];
                return options.includes(className) ? className : null;
            }
        },
        transitionBehavior: {
            label: 'Behavior',
            type: 'select',
            options: ['normal', 'allow-discrete'],
            default: 'normal',
            toClass: (value) => value ? `transition-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^transition-(normal|allow-discrete)$/);
                return match ? match[1] : null;
            }
        },
        transitionDuration: {
            label: 'Duration',
            type: 'select',
            options: ['0', '75', '100', '150', '200', '300', '500', '700', '1000'],
            default: '150',
            toClass: (value) => value ? `duration-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^duration-(.+)$/);
                return match ? match[1] : null;
            }
        },
        transitionTimingFunction: {
            label: 'Timing',
            type: 'select',
            options: ['linear', 'in', 'out', 'in-out'],
            default: 'in-out',
            toClass: (value) => value ? `ease-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^ease-(.+)$/);
                return match ? match[1] : null;
            }
        },
        transitionDelay: {
            label: 'Delay',
            type: 'select',
            options: ['0', '75', '100', '150', '200', '300', '500', '700', '1000'],
            default: '0',
            toClass: (value) => value ? `delay-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^delay-(.+)$/);
                return match ? match[1] : null;
            }
        },
        animation: {
            label: 'Animation',
            type: 'select',
            options: ['none', 'spin', 'ping', 'pulse', 'bounce'],
            default: 'none',
            toClass: (value) => value ? `animate-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^animate-(.+)$/);
                return match ? match[1] : null;
            }
        }
    }
};
